import React, { useState, useEffect, forwardRef, Fragment } from "react";
import { message, Divider, Row, Col, Icon } from 'antd';
import Title from 'antd/es/typography/Title';
import Paragraph from 'antd/es/typography/Paragraph';
import Text from 'antd/es/typography/Text';
import TranslatedText from "translations/TranslatedText";
import { fetchResponsesLocal, getQuizIdByName, fetchQuizLocal, } from 'quizdb';
import { getQuestionName, getQuizName, getAnswer,
         fetchResponses, pushResponseDB, } from 'lib';
import Score, { getShortName, } from './Score';
import { styled } from '@mui/material/styles';
import en from "translations/messages/en.json";

const ImageMarked = styled('span')(({ theme }) => ({
  width: '12%',
  left: '47%',
  position: 'absolute',
  bottom: '5%',
  borderBottom: '3px solid #F56626',
}));

function getHanziLevel(quizName) {
  if (quizName.includes('Level 1')) return 'level1';
  if (quizName.includes('Level 2')) return 'level2';
  if (quizName.includes('Level 3')) return 'level3';
}

function getShowAnswers(quizName) {
  if (quizName.includes('China Quiz')) return true;
}

function getShowScore(quizName) {
  if (quizName.includes('China Quiz')) return true;
  if (quizName.includes('Placement Test')) return false;
  if (quizName.includes('Hanzi')) return true;
}

export default forwardRef((props: any, ref: any) => {
  const { inputData, language, checkAnswer, } = props,
    { questions, toolConfig, } = inputData;
    // { showScore } = toolConfig;

  const quizName = getQuizName();
  const quiz = fetchQuizLocal(quizName);
  let score = 0, numQuestions = 0;
  const responses = fetchResponses();
  const quizEntries = Object.entries(quiz.questions);
  quizEntries.forEach((quizEntry) => {
    const questionId = quizEntry[0];
    let response;
    if (quiz.name in responses) response = responses[quiz.name][questionId];
    const question = quizEntry[1];
    const answer = getAnswer(question);
    if (response !== undefined && response == answer) score++
    if (!quizEntry[1].name.includes('Finish Page')) numQuestions++;
  });
  const showScore = getShowScore(quizName);
  const showAnswers = getShowAnswers(quizName);
  const showConclusion = quizName.includes('Placement Test');
  const quizShortName = getShortName(quizName);
  const isHanziQuiz = quizName.includes('Hanzi');

  return (
    <Row type="flex" justify="center"
         align="top"
         style={{ height: "100vh", marginTop: '0vh', }}
     >
      <Col>
        <Row style={{ marginBottom: '3%', }} type="flex" justify="center" align="middle">
          <Col>
            <Text style={{
              color: '#FF5A00', fontSize: '5em', fontFamily: 'AvenirNextLTPro-Bold',
            }}><TranslatedText id="student.message.finished.heading" /></Text>
            <ImageMarked />
          </Col>
        </Row>
        <Row style={{ marginBottom: '3%', }} type="flex" justify="center" align="middle">
          <Col>
            <Text style={{
              color: 'black', fontSize: '2.25em', fontWeight: '600',
              fontFamily: 'AvenirNextLTPro-Bold',
            }}><TranslatedText id="student.message.finished.introduction" />&nbsp;{getQuizName()}.</Text>
          </Col>
        </Row>
        {
          showScore && (
            <Row style={{ marginBottom: showConclusion ? '2%' : 0, }} type="flex" justify="center" align="middle">
              <Col>
                <Score quiz={quiz}
                       score={score} numQuestions={numQuestions}
                       quizName={quizName} showAnswers={showAnswers}
                />
              </Col>
            </Row>
          )
        }
        {
          showConclusion && (
            <Row type="flex" justify="center" align="middle">
              <Col>
                <Text style={{
                  color: 'black', fontFamily: 'AvenirNextLTPro-Regular',
                }}>
                  <TranslatedText id="student.message.finished.placement.conclusion" />
                </Text>
              </Col>
            </Row>
          )
        }
        {
          isHanziQuiz && (
            <Row type="flex" justify="center">
              <Col>
                <Title style={{ lineHeight: 0, fontFamily: 'AvenirNextLTPro-Regular',}} level={4}>
                  <a href={en[`student.message.finished.${quizShortName}.${getHanziLevel(quizName)}.nextquiz.url`]} target="_blank noopener">
                    <TranslatedText id={`student.message.finished.${quizShortName}.${getHanziLevel(quizName)}.nextquiz.text`} />
                  </a>
                </Title>
              </Col>
            </Row>
          )
        }
      </Col>
    </Row>
  );
})
